import { useEffect, useRef, useState } from "react";
import apiService from "../../../services/apiService";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import axios from "axios";

const PrintView = () => {
  const [questions, setQuestions] = useState([]);
  const [title, setTitle] = useState("");
  const [task, setTask] = useState();
  const taskId = useParams().id;

  // useEffect(()=>{
  //     apiService.request_old(`/i/ims/taskquestion/${taskId}?populate=subject,course,stream,curriculum,template`,{method:'GET'})
  //     .then((response)=>{
  //         console.log(response)
  //         setTask(response)
  //         setQuestions(response.questionImages)
  //         setTitle(response.title)
  //     })
  // },[])

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       let result = await apiService.request_old(
  //         `/i/ims/taskquestion/${taskId}?populate=subject,course,stream,curriculum,template`,
  //         { method: "GET" },
  //       );
  //       const allUnits = await apiService.abc_request(
  //         `/admin/subjectunit?subject=${result.subject.id}&status=true`,
  //         { method: "GET" },
  //       );
  //       await Promise.all(
  //         result["units"].map(async (unit) => {
  //           unit.unitObject = allUnits.filter(
  //             (singleUnit) => singleUnit.id === unit.unitId,
  //           )[0];
  //           const allTopics = await axios.get(
  //             `https://r1.edkt.net/api/i/ims/topic?unit=${unit.unitId}&status=true`,
  //             {
  //               headers: {
  //                 //Token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWU5MDc2ZmYzYTE4ZTQ2OGM5MWE1NjFjIiwiZmlyc3ROYW1lIjoiQWJjIiwibGFzdE5hbWUiOiJTY2hvb2wiLCJlbWFpbCI6ImFiY3NjaG9vbEBnbWFpbC5jb20iLCJtb2JpbGUiOiI5NDE0NzQ3NjA3IiwidXNlcm5hbWUiOiJhYmNzY2hvb2xAZ21haWwuY29tIiwidHlwZSI6IkFETUlOIiwiY2xpZW50IjoiNWU5MDc2ZmU4MDdjOGIwNWE4M2U4YjhmIiwiZGVmYXVsdFBhcmFtcyI6e319LCJpYXQiOjE3NTc5MTU4OTgsImF1ZCI6ImV6dWtpdC5jb20iLCJpc3MiOiJFenVraXQifQ.2QdgGHJCQFRitVgpFP8YcF2FbzYP-mE2aiA2Sqngs44'
  //                 Token:
  //                   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWU5MDc2ZmYzYTE4ZTQ2OGM5MWE1NjFjIiwiZmlyc3ROYW1lIjoiQWJjIiwibGFzdE5hbWUiOiJTY2hvb2wiLCJlbWFpbCI6ImZha2UxMzAyNkBnbWFpbC5jb20iLCJtb2JpbGUiOiI4Mzg0ODIzOTkwIiwidXNlcm5hbWUiOiJhYmNzY2hvb2xAZ21haWwuY29tIiwidHlwZSI6IkFETUlOIiwiY2xpZW50IjoiNWU5MDc2ZmU4MDdjOGIwNWE4M2U4YjhmIiwiZGVmYXVsdFBhcmFtcyI6e319LCJpYXQiOjE3ODI3NDQ2NDgsImF1ZCI6ImV6dWtpdC5jb20iLCJpc3MiOiJFenVraXQifQ.m1u--XbWTzCx_3x0bFuzCTbhd9Pw26TyHhfkC6itGmk",
  //               },
  //             },
  //           );
  //           unit.topics.forEach((topic) => {
  //             topic.topicObject = allTopics["data"].filter(
  //               (singleTopic) => singleTopic.id === topic.topicId,
  //             )[0];
  //           });
  //           return unit;
  //         }),
  //       );

  //       console.log(result);
  //       setTask(result);
  //       setQuestions(result.questionImages);
  //       setTitle(result.title);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };

  //   fetchData();
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiService.request_old(
          `/i/ims/taskquestion/${taskId}?populate=subject,course,stream,curriculum,template`,
          { method: "GET" },
        );

        const record = result?.data || result;
        const taskData = record?.taskId || record;

        const allUnits = await apiService.request_old(
          `/i/admin/subjectunit?subject=${taskData?.subject?.id}&status=true&limit=all`,
          { method: "GET" },
        );

        await Promise.all(
          (taskData?.units || []).map(async (unit) => {
            unit.unitObject = (allUnits?.data || allUnits || []).filter(
              (singleUnit) => singleUnit.id === unit.unitId,
            )[0];

            const allTopics = await apiService.request_old(
              `/i/ims/topic?unit=${unit.unitId}&status=true&limit=all`,
              {
                method: "GET",
              },
            );

            const topicsArr = allTopics?.data || allTopics || [];

            unit.topics.forEach((topic) => {
              topic.topicObject = topicsArr.filter(
                (singleTopic) => singleTopic.id === topic.topicId,
              )[0];
            });
            return unit;
          }),
        );
        // await Promise.all(
        //   (taskData?.units || []).map(async (unit) => {
        //     unit.unitObject = (allUnits?.data || allUnits || []).filter(
        //       (singleUnit) => singleUnit.id === unit.unitId,
        //     )[0];

        //     const allTopics = await axios.get(
        //       `https://r1.edkt.net/api/i/ims/topic?unit=${unit.unitId}&status=true`,
        //       {
        //         headers: {
        //           Token:
        //             "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWU5MDc2ZmYzYTE4ZTQ2OGM5MWE1NjFjIiwiZmlyc3ROYW1lIjoiQWJjIiwibGFzdE5hbWUiOiJTY2hvb2wiLCJlbWFpbCI6ImZha2UxMzAyNkBnbWFpbC5jb20iLCJtb2JpbGUiOiI4Mzg0ODIzOTkwIiwidXNlcm5hbWUiOiJhYmNzY2hvb2xAZ21haWwuY29tIiwidHlwZSI6IkFETUlOIiwiY2xpZW50IjoiNWU5MDc2ZmU4MDdjOGIwNWE4M2U4YjhmIiwiZGVmYXVsdFBhcmFtcyI6e319LCJpYXQiOjE3ODI3NDQ2NDgsImF1ZCI6ImV6dWtpdC5jb20iLCJpc3MiOiJFenVraXQifQ.m1u--XbWTzCx_3x0bFuzCTbhd9Pw26TyHhfkC6itGmk",
        //         },
        //       },
        //     );

        //     unit.topics.forEach((topic) => {
        //       topic.topicObject = allTopics["data"].filter(
        //         (singleTopic) => singleTopic.id === topic.topicId,
        //       )[0];
        //     });

        //     return unit;
        //   }),
        // );

        console.log("record", record);
        console.log("taskData", taskData);

        setTask(taskData);
        setQuestions(record?.questionImages || []);
        setTitle(taskData?.title || "");
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
  });

  return (
    <div className="flex flex-col">
      <div>
        <button
          onClick={handlePrint}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Print
        </button>
      </div>

      <div ref={componentRef} className="p-2">
        <div className="">
          <p className="font-extrabold text-4xl text-center">{title}</p>
        </div>

        <div className="mt-3">
          <table className="w-full border border-gray-300 rounded-lg shadow-md">
            {" "}
            {/*min-w-[300px]*/}
            <tbody>
              <tr className="border-b last:border-none">
                <th className="w-1/3 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Subject
                </th>
                <td className="py-3 px-4 text-gray-800">
                  {task?.subject?.name || "-"}
                </td>
              </tr>

              <tr className="border-b last:border-none">
                <th className="w-1/3 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Course
                </th>
                <td className="py-3 px-4 text-gray-800">
                  {task?.course["value"]}
                </td>
              </tr>

              <tr className="border-b last:border-none">
                <th className="w-1/3 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Stream
                </th>
                <td className="py-3 px-4 text-gray-800">
                  {task?.stream?.value || "-"}
                </td>
              </tr>

              <tr className="border-b last:border-none">
                <th className="w-1/3 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Curriculum
                </th>
                <td className="py-3 px-4 text-gray-800">
                  {task?.curriculum?.name || "-"}
                </td>
              </tr>

              <tr className="border-b last:border-none">
                <th className="w-1/3 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Template
                </th>
                <td className="py-3 px-4 text-gray-800">
                  {task?.template?.value?.title || task?.template?.title || "-"}
                </td>
              </tr>

              <tr className="border-b last:border-none">
                <th className="w-1/3 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Total Questions
                </th>
                <td className="py-3 px-4 text-gray-800">
                  {task?.totalQuestion}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-5 mb-5">
          <table className="w-full border border-gray-300 rounded-lg shadow-md">
            <thead>
              <tr>
                <td className="w-2/6 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Unit
                </td>
                <td className="w-1/6 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Topics
                </td>
                <td className="w-1/6 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Type
                </td>
                <td className="w-1/6 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  Difficulty
                </td>
                <td className="w-1/6 py-3 px-4 text-left bg-gray-100 font-semibold text-gray-700">
                  No of Questions
                </td>
              </tr>
            </thead>

            <tbody>
              {task?.units.map((unit, i) =>
                unit["topics"].map((topic, j) => (
                  <tr key={`${i}-${j}`}>
                    <td className="w-2/6 py-3 px-4 text-gray-800">
                      {unit.unitObject?.name}
                    </td>
                    <td className="w-1/6 py-3 px-4 text-gray-800">
                      {topic.topicObject?.name}
                    </td>
                    <td className="w-1/6 py-3 px-4 text-gray-800">
                      {topic.type}
                    </td>
                    <td className="w-1/6 py-3 px-4 text-gray-800">
                      {topic.difficulty}
                    </td>
                    <td className="w-1/6 py-3 px-4 text-gray-800">
                      {topic.questions}
                    </td>
                  </tr>
                )),
              )}
            </tbody>
          </table>
        </div>

        <div>
          {questions
            ? questions.map((question, index) => (
                <div key={index} className="m-5">
                  <div className="p-2">
                    <p className="font-semibold">
                      Question-{question.questionNum}
                    </p>
                  </div>
                  <div className="p-2">
                    <p>Answer-{question?.answer}</p>
                  </div>
                  <div className="p-2">
                    {question.imagesArr.map((imageUrl) => (
                      <img src={imageUrl} />
                    ))}
                  </div>
                  <hr className="h-4 bg-brown-800 border-0 mb-12 mt-12" />
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default PrintView;
